import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Define a type for the slice state
interface BlogPost {
    _id: string;
    title: string;
    content: string;
    author: string;
    category: string;
    tags: string[];
    imageUrl: string; // Add imageUrl to the BlogPost interface
    date: string; // Date in string format
    __v: number;
}

interface BlogState {
    posts: BlogPost[];
    loading: boolean;
    error: string | null;
    totalPages: number;
    currentPage: number;
    totalPosts: number;
}

// Define the initial state
const initialState: BlogState = {
    posts: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
    totalPosts: 0,
};

// Define an async thunk to fetch blog posts with pagination
export const fetchPosts = createAsyncThunk(
    'blog/fetchPosts',
    async (page: number) => {
        const limit = 12;  // Set the limit to 9 posts per page
        const response = await axios.get(`${API_URL}/blog?page=${page}&limit=${limit}`);
        return response.data;  // This should return posts, totalPages, currentPage, totalPosts
    }
);

// Create the slice
const blogSlice = createSlice({
    name: 'blog',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPosts.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchPosts.fulfilled, (state, action) => {
                state.loading = false;
                state.posts = action.payload.posts;
                state.totalPages = action.payload.totalPages;
                state.currentPage = action.payload.currentPage;
                state.totalPosts = action.payload.totalPosts;
            })
            .addCase(fetchPosts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch posts';
            });
    },
});

export default blogSlice.reducer;

